module.exports = __webpack_public_path__ + "img/user-1.bf247429.svg";